import { render, staticRenderFns } from "./ReceiptPopup.vue?vue&type=template&id=8ada43e0"
import script from "./ReceiptPopup.vue?vue&type=script&lang=js"
export * from "./ReceiptPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports